import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

import { TooltipModule } from 'primeng/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    standalone: true,
    imports: [NgClass, FontAwesomeModule, TooltipModule],
    selector: 'qwyk-info',
    templateUrl: './info-tooltip.component.html',
    styleUrls: ['./info-tooltip.component.scss'],
})
export class InfoTooltipComponent {
    @Input() text: string;
    @Input() class = '';
}
